/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import { Skeleton } from '@material-ui/lab';
import { usersAPI } from 'src/api/modules/users';
import notice from 'src/common/components/Notice';
import React, { useState, useEffect } from 'react';
import BaseModal from 'src/common/components/Modal';
import { makeStyles, Grid } from '@material-ui/core';
import { sessionsAPI } from 'src/api/modules/sessions';
import FullTable from 'src/common/components/FullTable';
import EditorText from 'src/common/components/EditorText';
import UtilInputs from 'src/common/components/UtilInputs';
import templateConvocatoria from './utils/template-convocatoria';
import { templateSession } from './utils/template-session';
import { templateSessionFilial } from './utils/template-session-filial';
import { templateFilial } from './utils/template-filial';
import CustomButton from 'src/common/components/CustomButton';
import { useSavePublishSession } from './hooks/useSavePublishSession';
import {
	columnsUpcomingSessions,
	columnsAnnouncement,
	buttons,
	btnsSave,
} from './utils/list_data';

const useStyles = makeStyles({
	subTitle2: {
		fontSize: 21,
	},
	containerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
	},
});

export const getFullDate = (date) => {
	const fecha_original = new Date(date);
	const dia = fecha_original.getDate();
	const mes = fecha_original.toLocaleString('default', { month: 'long' });
	const anio = fecha_original.getFullYear();
	const hora = fecha_original.getHours();
	const minutos = fecha_original.getMinutes();
	return `${dia} de ${mes} del ${anio} a las ${hora}:${minutos} hrs`;
};
const PublishSendSessionModal = ({
	open,
	setOpen,
	idSession,
	file,
	nameFile,
	organID,
	dataSession,
}) => {
	const classes = useStyles();
	const filial = localStorage.getItem('type');
	const [allSelected, setAllSelected] = useState([]);
	const [allSelectedEnviar, setAllSelectedEnviar] = useState([]);
	const [users, setUsers] = useState([]);
	const [filters1, setFilters1] = useState(false);
	const [filters2, setFilters2] = useState(false);
	const [saveConv, setSaveConv] = useState(false);
	const [optionUsers, setOptionUsers] = useState([]);
	const [inputUser, setInputUser] = useState({
		users1: [],
		users2: [],
	});
	const [inputValues, setInputValues] = useState({
		sector1: '',
		sector2: '',
		usuarios1: '',
		usuarios2: '',
	});
	const [mailSession, setMailSession] = useState('');
	const [mailAnnouncement, setMailAnnouncement] = useState('');
	const { user } = useSelector((state) => state.auth);
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';

	const { dataSaved, onSaveData, loading } = useSavePublishSession(
		open,
		idSession,
		inputUser,
		mailSession,
		mailAnnouncement,
		setInputUser,
		users
	);

	useEffect(() => {
		setMailSession(
			filial ? templateSessionFilial(dataSession) : templateSession(dataSession)
		);
		setMailAnnouncement(
			filial ? templateFilial(dataSession) : templateConvocatoria(dataSession)
		);
	}, [dataSession]);

	useEffect(() => {
		if (organID) getUsers(organID);
	}, [organID]);

	const onCheckboxPublicar = (id) => {
		let usersSelected = [];
		if (allSelected.includes(id)) {
			const items = allSelected.filter((delId) => delId !== id);
			setAllSelected(items);
			usersSelected = users.filter((user) => items.includes(user.id));
		} else {
			usersSelected = users.filter((user) =>
				[...allSelected, id].includes(user.id)
			);
			setAllSelected([...allSelected, id]);
		}
		setInputUser({
			users1: [...inputUser.users1],
			users2: usersSelected.map((user) => ({
				text: user.name,
				value: user.id,
			})),
		});
	};
	const onCheckboxEnviar = (id, status) => {
		let userSelected1 = [];
		let userSelected2 = [];
		if (allSelectedEnviar.includes(id)) {
			const items = allSelectedEnviar.filter((delId) => delId !== id);
			setAllSelectedEnviar(items);
			userSelected1 = users.filter((user) => items.includes(user.id));
		} else {
			userSelected1 = users.filter((user) =>
				[...allSelected, id].includes(user.id)
			);
			setAllSelectedEnviar([...allSelected, id]);
		}
		if (allSelected.length === 0) {
			setAllSelected([...allSelectedEnviar, id]);
			userSelected2 = users.filter((user) =>
				[...allSelectedEnviar, id].includes(user.id)
			);
		} else {
			if (status && allSelected.includes(id)) {
				const items = allSelected.filter((delId) => delId !== id);
				setAllSelected(items);
				userSelected2 = users.filter((user) => items.includes(user.id));
			} else if (!status && !allSelected.includes(id)) {
				setAllSelected([...allSelected, id]);
				userSelected2 = users.filter((user) =>
					[...allSelectedEnviar, id].includes(user.id)
				);
			}
		}

		setInputUser({
			users1: userSelected1.map((user) => ({ text: user.name, value: user.id })),
			users2: userSelected1.map((user) => ({ text: user.name, value: user.id })),
		});
	};

	const unmarkAllBtnFn = (usersFilter, affectBoth = false) => {
		const usersSectorTipoData = usersFilter;
		const userSectorTipoIds = usersSectorTipoData.map((user) => user.id);
		if (affectBoth) {
			setAllSelectedEnviar(
				allSelectedEnviar.filter((item) => !userSectorTipoIds.includes(item))
			);
		}
		setAllSelected(allSelected.filter((item) => !userSectorTipoIds.includes(item)));
		setInputUser({
			users1: affectBoth
				? inputUser.users1.filter(
						(user) => !userSectorTipoIds.includes(user.value)
				  )
				: [...inputUser.users1],
			users2: inputUser.users2.filter(
				(user) => !userSectorTipoIds.includes(user.value)
			),
		});
	};
	const markAllBtnFn = (usersFilters, affectBoth = false) => {
		const getUsersTipoSector = usersFilters;
		const getUsersTipoSectorID = getUsersTipoSector.map((user) => user.id);
		if (affectBoth) {
			setAllSelectedEnviar([...allSelectedEnviar, ...getUsersTipoSectorID]);
		}
		setAllSelected([...allSelected, ...getUsersTipoSectorID]);
		setInputUser({
			users1: affectBoth
				? [
						...inputUser.users1,
						...getUsersTipoSector.map((user) => ({
							text: user.name,
							value: user.id,
						})),
				  ]
				: [...inputUser.users1],
			users2: [
				...inputUser.users2,
				...getUsersTipoSector.map((user) => ({
					text: user.name,
					value: user.id,
				})),
			],
		});
	};

	const markAll = () => {
		if (inputValues.sector2 === '' && inputValues.usuarios2 === '') {
			if (allSelected.length === users.length) {
				setAllSelected('');
				setInputUser({
					users1: [...inputUser.users1],
					users2: [],
				});
			} else {
				setAllSelected(users.map((user) => user.id));
				setInputUser({
					users1: [...inputUser.users1],
					users2: users.map((user) => ({
						text: user.name,
						value: user.id,
					})),
				});
			}
			return;
		}
		if (inputValues.sector2 !== '' && inputValues.usuarios2 !== '') {
			const usersFiltered = users.filter(
				(item) =>
					item?.sector?.toLowerCase() === inputValues?.sector2?.toLowerCase() &&
					item?.tipo?.toLowerCase() === inputValues?.usuarios2?.toLowerCase()
			);
			if (
				users
					.filter(
						(item) =>
							item?.sector?.toLowerCase() ===
								inputValues?.sector2?.toLowerCase() &&
							item?.tipo?.toLowerCase() ===
								inputValues?.usuarios2?.toLowerCase()
					)
					.every((item) => allSelected.includes(item.id))
			) {
				unmarkAllBtnFn(usersFiltered);
			} else {
				markAllBtnFn(usersFiltered);
			}
			return;
		}
		if (inputValues.sector2 !== '') {
			const usersFiltered = users.filter(
				(item) =>
					item?.sector?.toLowerCase() === inputValues?.sector2?.toLowerCase()
			);
			if (
				users
					.filter(
						(item) =>
							item?.sector?.toLowerCase() ===
							inputValues?.sector2?.toLowerCase()
					)
					.every((item) => allSelected.includes(item.id))
			) {
				unmarkAllBtnFn(usersFiltered);
			} else {
				markAllBtnFn(usersFiltered);
			}
		}
		if (inputValues.usuarios2 !== '') {
			const usersFiltered = users.filter(
				(item) =>
					item?.tipo?.toLowerCase() === inputValues?.usuarios2?.toLowerCase()
			);
			if (
				users
					.filter(
						(item) =>
							item?.tipo?.toLowerCase() ===
							inputValues?.usuarios2?.toLowerCase()
					)
					.every((item) => allSelected.includes(item.id))
			) {
				unmarkAllBtnFn(usersFiltered);
			} else {
				markAllBtnFn(usersFiltered);
			}
		}
	};

	const markAllEnviar = () => {
		const affectBoth = true;
		if (inputValues.sector1 === '' && inputValues.usuarios1 === '') {
			if (allSelectedEnviar.length === users.length) {
				setAllSelectedEnviar('');
				setAllSelected('');
				setInputUser({
					users1: [],
					users2: [],
				});
			} else {
				setAllSelectedEnviar(users.map((user) => user.id));
				setAllSelected(users.map((user) => user.id));
				setInputUser({
					users1: users.map((user) => ({
						text: user.name,
						value: user.id,
					})),
					users2: users.map((user) => ({
						text: user.name,
						value: user.id,
					})),
				});
			}
			return;
		}
		if (inputValues.sector1 !== '' && inputValues.usuarios1 !== '') {
			const usersFiltered = users.filter(
				(item) =>
					item?.sector?.toLowerCase() === inputValues?.sector1?.toLowerCase() &&
					item?.tipo?.toLowerCase() === inputValues?.usuarios1?.toLowerCase()
			);
			if (
				users
					.filter(
						(item) =>
							item?.sector?.toLowerCase() ===
								inputValues?.sector1?.toLowerCase() &&
							item?.tipo?.toLowerCase() ===
								inputValues?.usuarios1?.toLowerCase()
					)
					.every((item) => allSelectedEnviar.includes(item.id))
			) {
				unmarkAllBtnFn(usersFiltered, affectBoth);
			} else {
				markAllBtnFn(usersFiltered, affectBoth);
			}
			return;
		}
		if (inputValues.sector1 !== '') {
			const usersFiltered = users.filter(
				(item) =>
					item?.sector?.toLowerCase() === inputValues?.sector1?.toLowerCase()
			);
			if (
				users
					.filter(
						(item) =>
							item?.sector?.toLowerCase() ===
							inputValues?.sector1?.toLowerCase()
					)
					.every((item) => allSelectedEnviar.includes(item.id))
			) {
				unmarkAllBtnFn(usersFiltered, affectBoth);
			} else {
				markAllBtnFn(usersFiltered, affectBoth);
			}
		}
		if (inputValues.usuarios1 !== '') {
			const usersFiltered = users.filter(
				(item) =>
					item?.tipo?.toLowerCase() === inputValues?.usuarios1?.toLowerCase()
			);
			if (
				users
					.filter(
						(item) =>
							item?.tipo?.toLowerCase() ===
							inputValues?.usuarios1?.toLowerCase()
					)
					.every((item) => allSelectedEnviar.includes(item.id))
			) {
				unmarkAllBtnFn(usersFiltered, affectBoth);
			} else {
				markAllBtnFn(usersFiltered, affectBoth);
			}
		}
	};

	const getUsers = (organID) => {
		usersAPI
			.getUsersByOrgan(organID)
			.then((response) => {
				if (response.usuarios && response.usuarios.length > 0) {
					let usersName = [];
					response.usuarios.forEach((item) => {
						usersName.push({
							id: item.id,
							name: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
							sector:
								item.sector === 'SG'
									? 'Sector Gobierno'
									: item.sector === 'ST'
									? 'Sector Trabajador'
									: item.sector === 'SE'
									? 'Sector Empresarial'
									: item.sector === ''
									? 'Sin Sector'
									: item.sector,
							position:
								item.cargo === 'PR'
									? 'Propietario'
									: item.cargo === 'SU'
									? 'Suplente'
									: item.cargo === 'TI'
									? 'Titular'
									: item.cargo === 'SUP'
									? 'Suplente'
									: item.cargo === ''
									? 'Sin Cargo'
									: item.cargo,
							tipo: item.tipo,
						});
					});

					setUsers(usersName);
					setOptionUsers(
						usersName.map((item) => ({ value: item.id, text: item.name }))
					);
				} else {
					notice('No se encontraron resultados', 'info');
					setUsers([]);
				}
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'info');
			});
	};

	const post = () => {
		let scapeAnn = mailAnnouncement.replaceAll('“', '"');
		let scapeAnnEnd = scapeAnn.replaceAll('”', '"');

		let scapeSess = mailSession.replaceAll('“', '"');
		let scapeSessEnd = scapeSess.replaceAll('”', '"');

		let allList = [...new Set(inputUser.users2.map((user) => user.value))];
		let allListConvo = [...new Set(inputUser.users1.map((user) => user.value))];

		let bodySession = {
			mensajes: scapeSessEnd
				.replace(/’/g, '"')
				.replace(/'/g, '"')
				.replaceAll("'", '"')
				.replaceAll('‘', '"'),
			usuariosIds: allList,
			idUsuario: user.id,
		};
		let bodyAnnouncement = {
			mensajes: scapeAnnEnd
				.replace(/’/g, '"')
				.replace(/'/g, '"')
				.replaceAll("'", '"')
				.replaceAll('‘', '"'),
			usuariosIds: allListConvo,
			archivo: { file: file, fileName: nameFile },
			idUsuario: user.id,
		};

		if (allList.length > 0)
			sessionsAPI
				.postSession(idSession, bodySession, filial ? '?isFilial=true' : null)
				.then((response) => {
					notice('Se ha publicado la sessión con éxito', 'success');
				})
				.catch(() => {
					notice('Ocurrio un problema al publicar la sesión', 'error');
				});

		if (allListConvo.length > 0)
			sessionsAPI
				.postAnnouncement(
					idSession,
					bodyAnnouncement,
					filial ? '?isFilial=true' : null
				)
				.then((response) => {
					setTimeout(() => {
						if (
							response.codigo === 'SAOC-400' ||
							response.codigo === 'SAOC: 500'
						)
							notice(JSON.parse(JSON.stringify(response?.mensaje)));
						else notice('Se ha enviado la convocatoria con exito', 'success');
					}, 500);
					setTimeout(() => {
						window.location.reload();
					}, 500);
				})
				.catch((e) => {
					if (isDev) {
						if (e.response.data === undefined || e.response.data === '') {
							notice('Ocurrio un error al enviar la convocatoria');
						} else notice(e?.response?.data?.mensaje);
					} else notice('Ocurrio un error al enviar la convocatoria');
				});

		setOpen(false);
	};

	const handleChangeValues = ({ target }) => {
		const { name, value } = target;
		setInputValues({ ...inputValues, [name]: value });
	};

	const sectorSelect1 = [
		{
			label: 'Representación',
			name: 'sector1',
			type: 'dropdown',
			options: [
				{ value: 'Sector Gobierno', text: 'Sector Gobierno' },
				{ value: 'Sector Trabajador', text: 'Sector Trabajador' },
				{ value: 'Sector Empresarial', text: 'Sector Empresarial' },
				{ value: 'Sin Sector', text: 'Sin Sector' },
			],
			column: 12,
		},
	];
	const sectorSelect2 = [
		{
			label: 'Representación',
			name: 'sector2',
			type: 'dropdown',
			options: [
				{ value: 'Sector Gobierno', text: 'Sector Gobierno' },
				{ value: 'Sector Trabajador', text: 'Sector Trabajador' },
				{ value: 'Sector Empresarial', text: 'Sector Empresarial' },
				{ value: 'Sin Sector', text: 'Sin Sector' },
			],
			column: 12,
		},
	];
	const usuarios1 = [
		{
			label: 'Usuarios',
			name: 'usuarios1',
			type: 'dropdown',
			options: [{ value: 'INT', text: 'Administración General' }],
			containerClass: {
				maxWidth: '100% !important',
				flexBasis: '100% !important',
				border: '1px solid black',
			},
			column: 12,
		},
	];
	const usuarios2 = [
		{
			label: 'Usuarios',
			name: 'usuarios2',
			type: 'dropdown',
			options: [{ value: 'INT', text: 'Administración General' }],
			column: 12,
		},
	];
	const getItems1 = (users) => {
		if (inputValues.sector1 === '' && inputValues.usuarios1 === '') return users;
		let usersFiltered = [...users];
		if (inputValues.sector1 !== '') {
			usersFiltered = usersFiltered.filter(
				(item) =>
					item?.sector?.toLowerCase() === inputValues?.sector1?.toLowerCase()
			);
		}
		if (inputValues.usuarios1 !== '') {
			usersFiltered = usersFiltered.filter(
				(item) =>
					item?.tipo?.toLowerCase() === inputValues?.usuarios1?.toLowerCase()
			);
		}

		return usersFiltered;
	};
	const getItems2 = (users) => {
		if (inputValues.sector2 === '' && inputValues.usuarios2 === '') return users;
		let usersFiltered = [...users];
		if (inputValues.sector2 !== '') {
			usersFiltered = usersFiltered.filter(
				(item) =>
					item?.sector?.toLowerCase() === inputValues?.sector2?.toLowerCase()
			);
		}
		if (inputValues.usuarios2 !== '') {
			usersFiltered = usersFiltered.filter(
				(item) =>
					item?.tipo?.toLowerCase() === inputValues?.usuarios2?.toLowerCase()
			);
		}

		return usersFiltered;
	};
	const markBtnConv = () => {
		let msg = 'Marcar todos';
		if (inputValues.sector1 === '' && inputValues.usuarios1 === '') {
			allSelectedEnviar.length === users.length
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
			return msg;
		}
		if (inputValues.sector1 !== '' && inputValues.usuarios1 !== '') {
			users
				.filter(
					(item) =>
						item?.sector?.toLowerCase() ===
							inputValues?.sector1?.toLowerCase() &&
						item?.tipo?.toLowerCase() ===
							inputValues?.usuarios1?.toLowerCase()
				)
				.every((item) => allSelectedEnviar.includes(item.id))
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
			return msg;
		}
		if (inputValues.sector1 !== '') {
			users
				.filter(
					(item) =>
						item?.sector?.toLowerCase() ===
						inputValues?.sector1?.toLowerCase()
				)
				.every((item) => allSelectedEnviar.includes(item.id))
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
		}
		if (inputValues.usuarios1 !== '') {
			users
				.filter(
					(item) =>
						item?.tipo?.toLowerCase() ===
						inputValues?.usuarios1?.toLowerCase()
				)
				.every((item) => allSelectedEnviar.includes(item.id))
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
		}
		return msg;
	};
	const markBtnSes = () => {
		let msg = 'Marcar todos';
		if (inputValues.sector2 === '' && inputValues.usuarios2 === '') {
			allSelected.length === users.length
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
			return msg;
		}
		if (inputValues.sector2 !== '' && inputValues.usuarios2 !== '') {
			allSelected.length ===
			users
				.filter(
					(item) =>
						item?.sector?.toLowerCase() ===
							inputValues?.sector2?.toLowerCase() &&
						item?.tipo?.toLowerCase() ===
							inputValues?.usuarios2?.toLowerCase()
				)
				.every((item) => allSelected.includes(item.id))
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
			return msg;
		}
		if (inputValues.sector2 !== '') {
			users
				.filter(
					(item) =>
						item?.sector?.toLowerCase() ===
						inputValues?.sector2?.toLowerCase()
				)
				.every((item) => allSelected.includes(item.id))
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
		}
		if (inputValues.usuarios2 !== '') {
			users
				.filter(
					(item) =>
						item?.tipo?.toLowerCase() ===
						inputValues?.usuarios2?.toLowerCase()
				)
				.every((item) => allSelected.includes(item.id))
				? (msg = 'Desmarcar todos')
				: (msg = 'Marcar todos');
		}
		return msg;
	};

	const handleChange1 = ({ target }) => {
		const { value } = target;
		setInputUser({
			users1: value,
			users2: value,
		});
		setAllSelectedEnviar(value.map((item) => item.value));
		setAllSelected(value.map((item) => item.value));
	};
	const handleChange2 = ({ target }) => {
		const { value } = target;
		setInputUser({
			users1: [...inputUser.users1],
			users2: value,
		});
		setAllSelected(value.map((item) => item.value));
	};

	const saveShow = () => {
		setSaveConv(!saveConv);
		onSaveData();
	};

	return (
		<BaseModal
			open={open}
			mainText="Publicar y Enviar Sesión"
			onClose={() => setOpen(false)}
			onCancel={() => setOpen(false)}
			maxWidth="lg"
		>
			{!loading && (
				<>
					{btnsSave(saveShow, () => setSaveConv(!saveConv), saveConv).map(
						(button) => (
							<CustomButton
								key={'btn' + button.title}
								mainText={button.title}
								color={button.color}
								onClick={button.onClick}
								disabled={button.disabled}
								className={button.className}
								variant="main-outlined"
							/>
						)
					)}

					{!saveConv && (
						<Grid container className="mb-8 float-right" spacing={2}>
							<div className={classes.subTitle2}>
								Mensaje para Convocatoria
							</div>
							<Grid item md={12}>
								<EditorText
									defaultHTML={
										dataSaved?.mensajeConvocatoria
											? dataSaved?.mensajeConvocatoria
											: mailAnnouncement
									}
									setValueEnd={setMailAnnouncement}
								/>
							</Grid>
							{optionUsers.length !== 0 ? (
								<div className={classes.containerButtons}>
									<UtilInputs
										width="100%"
										inputValues={[
											{
												label: 'Usuarios',
												name: 'users1',
												type: 'search-multiple',
												options: [...optionUsers],
												column: 12,
											},
										]}
										formValues={inputUser}
										onValuesChange={handleChange1}
									/>
									<CustomButton
										mainText={
											filters1
												? 'Ocultar filtros'
												: 'Mostrar filtros'
										}
										onClick={() => setFilters1(!filters1)}
										width="100%"
										className={'mt-lg-5'}
									/>
								</div>
							) : (
								<Skeleton
									width={'100%'}
									height={50}
									variant="circular"
									animation="wave"
								/>
							)}
							{filters1 && (
								<div style={{ width: '100%' }}>
									<div className={classes.containerButtons}>
										<UtilInputs
											width="100%"
											inputValues={sectorSelect1}
											formValues={inputValues}
											onValuesChange={handleChangeValues}
										/>
										<UtilInputs
											width="100%"
											inputValues={usuarios1}
											formValues={inputValues}
											onValuesChange={handleChangeValues}
										/>
										<CustomButton
											mainText={markBtnConv()}
											onClick={markAllEnviar}
											className={'mt-lg-5'}
											width="100%"
										/>
									</div>
									<FullTable
										title="Destinatarios de Enviar Convocatoria"
										items={getItems1(users)}
										columns={columnsAnnouncement(
											onCheckboxEnviar,
											allSelectedEnviar
										)}
									/>
								</div>
							)}
						</Grid>
					)}
					{saveConv && (
						<Grid container className="float-right" spacing={2}>
							<Grid item md={12}>
								<div style={{ width: '100%' }}>
									<div className={classes.subTitle2}>
										Mensaje para Publicar Sesión
									</div>
									<Grid item md={12}>
										<EditorText
											defaultHTML={
												dataSaved?.mensajePublicarSesion
													? dataSaved?.mensajePublicarSesion
													: mailSession
											}
											setValueEnd={setMailSession}
										/>
									</Grid>
									{optionUsers.length !== 0 ? (
										<div className={classes.containerButtons}>
											<UtilInputs
												width="100%"
												inputValues={[
													{
														label: 'Usuarios',
														name: 'users2',
														type: 'search-multiple',
														options: [...optionUsers],
														column: 12,
													},
												]}
												formValues={inputUser}
												onValuesChange={handleChange2}
											/>
											<CustomButton
												mainText={
													filters2
														? 'Ocultar filtros'
														: 'Mostrar filtros'
												}
												onClick={() => setFilters2(!filters2)}
												width="100%"
												className={'mt-lg-5'}
											/>
										</div>
									) : (
										<Skeleton
											width={'100%'}
											height={50}
											variant="circular"
											animation="wave"
										/>
									)}
									{filters2 && (
										<>
											<div className={classes.containerButtons}>
												<UtilInputs
													width="100%"
													inputValues={sectorSelect2}
													formValues={inputValues}
													onValuesChange={handleChangeValues}
												/>
												<UtilInputs
													width="100%"
													inputValues={usuarios2}
													formValues={inputValues}
													onValuesChange={handleChangeValues}
												/>
												<CustomButton
													mainText={markBtnSes()}
													onClick={markAll}
													className={'mt-lg-5'}
												/>
											</div>
											<FullTable
												title="Destinatarios de Publicar Sesión"
												items={getItems2(users)}
												columns={columnsUpcomingSessions(
													onCheckboxPublicar,
													allSelected
												)}
											/>
										</>
									)}
								</div>
							</Grid>
							<div className={classes.containerButtons}>
								{buttons(post).map((button) => (
									<CustomButton
										key={button.title}
										mainText={button.title}
										color={button.color}
										onClick={button.onClick}
										className={'mt-lg-5'}
									/>
								))}
							</div>
						</Grid>
					)}
				</>
			)}
		</BaseModal>
	);
};

export default PublishSendSessionModal;
